import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const ShareMapPage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .leaflet-container{
    height: 100%;
  }
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover{
      opacity: 0.8;
    }
  }
  .button-group{
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
  .isoComponentTitle{
    margin-bottom: 15px;
  }
  .isoLeftRightComponent{
    padding: 8px 24px;
    background: #fff;
    border-bottom: 1px solid #eaeef1;
  }
  path.primary-objects{
    stroke-width: 2;
    &:hover{
      fill-opacity: 0.4;
      stroke: #fff;
    }
  }
  .primary-objects-tooltip{
    background: transparent;
    color: white;
    font-weight: 600;
    border: none;
    box-shadow: none;
  }
  .custom-icon-marker{

    width: 44px;
    height: 60px;
  }
  a[title="Clear all layers"]{
    display: none;
  }
 
  &.not-show-area .primary-objects {
    display: none; 
  }
  
  &.not-show-task .custom-icon-marker.task-marker {
    display: none; 
  }

  &.not-show-observation .custom-icon-marker.observation-marker {
    display: none; 
  }

  &.not-show-mob .custom-icon-marker.mob {
    display: none; 
  }
  .leaflet-draw-toolbar.leaflet-bar.leaflet-draw-toolbar-top{
    bottom:-11.5px;
    position:relative;
  }
  @media (max-width: 768px){
    .leaflet-draw-toolbar.leaflet-bar.leaflet-draw-toolbar-top{
      bottom:-15.5px;
      position:relative;
    }
  }
  .leaflet-draw-edit-edit{
    border-top-left-radius: unset!important;
    border-top-right-radius: unset!important;
  }

  .leaflet-draw-draw-polygon{
    border-bottom-left-radius: unset!important;
    border-bottom-right-radius: unset!important;
  }

  .numberCircle {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    padding: 5px;
    background: #fff;
    border: 2px solid #666;
    color: #666;
    text-align: center;
    font: 10px Arial,sans-serif;
    margin-top: -75px;
    margin-left: 25px;
    z-index: 9;
    position: absolute;
  }
`;

export default WithDirection(ShareMapPage);